// @flow
import * as React from 'react';
import type { Image as ImageType } from 'app/packages/pinterest-flow-types/image';
import { Box, Image, Mask } from 'gestalt';

type Props = {|
  height: number,
  image?: ImageType,
  width: number,
|};

export default function BoardCollageImage({ image, width, height }: Props) {
  return image ? (
    <Mask wash width={width} height={height}>
      <Image
        alt=""
        color="#EFEFEF"
        fit="cover"
        naturalHeight={image.height || 1}
        naturalWidth={image.width || 1}
        src={image.url || ''}
      />
    </Mask>
  ) : (
    <Box color="lightGray" width={width} height={height} />
  );
}
